const RECEIPTS = [
  {
    id: 1,
    date: new Date().toISOString().split("T")[0],
    totalRent: 200000,
    totalValue: 250000,
  },
  {
    id: 2,
    date: new Date().toISOString().split("T")[0],
    totalRent: 200000,
    totalValue: 250000,
  },
  {
    id: 3,
    date: new Date().toISOString().split("T")[0],
    totalRent: 200000,
    totalValue: 250000,
  },
  {
    id: 4,
    date: new Date().toISOString().split("T")[0],
    totalRent: 200000,
    totalValue: 250000,
  },
  {
    id: 5,
    date: new Date().toISOString().split("T")[0],
    totalRent: 200000,
    totalValue: 250000,
  },
  {
    id: 5,
    date: new Date().toISOString().split("T")[0],
    totalRent: 200000,
    totalValue: 250000,
  },
  {
    id: 7,
    date: new Date().toISOString().split("T")[0],
    totalRent: 200000,
    totalValue: 250000,
  },
];

export default RECEIPTS;
